import { createClient } from "@supabase/supabase-js";

const supabase = createClient('https://vblkszwkmbobuiqklznx.supabase.co', 'sb_publishable_XuyP81fLWQjr4k-Ao-CUIA_BSRtkRaB');

export default supabase;
